import React from 'react';
import { View, FlatList, StyleSheet } from 'react-native';

import CheckButton from './check_button';
import OPPureComponent from '../op_pure_component';
import TextInputPlain from './text_input_plain';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

export default class CheckButtonList extends OPPureComponent {
  constructor(props) {
    super(props);

    let inputText = '';
    let otherChecked = false;
    if (props.other && !props.multi) {
      if (props.value != null && !this.props.items.find((i) => i.id === props.value)) {
        inputText = props.value;
        otherChecked = true;
      }
    }

    this.state = {
      inputText,
      otherChecked,
    };
  }

  handlePressMulti = (id, checked) => {
    const newItems = this.props.items.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          checked,
        };
      }
      return item;
    });

    this.props.onValuesChanged(newItems);
  };

  handlePressSingle = (id, checked) => {
    if (id !== '_other_') {
      this.props.onValue(id);
      this.setState({ otherChecked: false, inputText: '' });
    } else {
      this.props.onValue(null);
      this.setState({ otherChecked: true });
    }
  };

  renderItemScrollable = ({ item }) => {
    return this.renderItem(item);
  };

  handleInputText = (text) => {
    this.setState({ inputText: text });
    this.props.onValue(text);
  };

  renderItem = (item) => {
    const { multi, value, renderRightView, disabled } = this.props;
    const { label, id, checked, other } = item;

    const editable = item.editable !== false;

    const isChecked = multi ? !!checked : value === id;
    let onPress;
    if (multi) {
      onPress = editable ? this.handlePressMulti : null;
    } else {
      onPress = disabled ? null : this.handlePressSingle;
    }

    if (!!other) {
      return (
        <View key={`${id}`} style={[THEME.basicRow]}>
          <CheckButton
            checked={this.state.otherChecked}
            label={null}
            value={id}
            item={item}
            disabled={!onPress}
            onPress={onPress}
            renderRightView={renderRightView}
            labelStyle={[styles.labelText, this.props.labelStyle]}
            disabledLabelStyle={this.props.disabledLabelStyle}
            containerStyle={[this.props.rowContainerStyle]}
            checkSize={this.props.buttonSize}
            noTopBorder={true}
            noBottomBorder={this.props.noBottomBorder}
            iconStyle={this.props.iconStyle}
            iconType={this.props.iconType}
          />
          {!!other && (
            <TextInputPlain
              autoFocus={false}
              editable={!!this.state.otherChecked}
              value={this.state.inputText}
              controlled={true}
              multiline={true}
              style={[styles.input, this.props.labelStyle]}
              placeholder={'Other'}
              placeholderTextColor={'rgb(170,170,170)'}
              onChangeText={this.handleInputText}
            />
          )}
        </View>
      );
    } else {
      return (
        <CheckButton
          key={`${id}`}
          checked={isChecked}
          label={label}
          value={id}
          item={item}
          disabled={!onPress}
          onPress={onPress}
          renderRightView={renderRightView}
          labelStyle={[styles.labelText, this.props.labelStyle]}
          disabledLabelStyle={this.props.disabledLabelStyle}
          containerStyle={[this.props.rowContainerStyle]}
          checkSize={this.props.buttonSize}
          noTopBorder={true}
          noBottomBorder={this.props.noBottomBorder}
          iconStyle={this.props.iconStyle}
          iconType={this.props.iconType}
        />
      );
    }
  };

  renderCol = (col, i) => {
    let items = this.props.items.filter((i) => col.includes(i.id));
    if (col.includes('_other_')) {
      items = items.concat({ id: '_other_', label: 'Other', other: true });
    }
    return (
      <View style={styles.col} key={i}>
        {items.map(this.renderItem)}
      </View>
    );
  };

  renderRow = (row, i) => {
    return (
      <View style={styles.row} key={i}>
        {row.map(this.renderCol)}
      </View>
    );
  };
  render() {
    const { value, multi, scrollable, containerStyle, other, customLayout, layoutOptions } =
      this.props;

    if (customLayout?.rows) {
      return <>{customLayout?.rows.map(this.renderRow)}</>;
    }

    let items = this.props.items || [];
    if (other && !multi) {
      items = items.concat({ id: '_other_', label: 'Other', other: true });
    }

    if (!scrollable) {
      return <View style={containerStyle || THEME.containerAlt}>{items.map(this.renderItem)}</View>;
    }

    if (scrollable) {
      return (
        <FlatList
          keyboardShouldPersistTaps={this.props.keyboardShouldPersistTaps || 'handled'}
          automaticallyAdjustContentInsets={false}
          data={items}
          renderItem={this.renderItemScrollable}
          keyExtractor={(item) => {
            return `${item.id}`;
          }}
        />
      );
    }
  }
}

const styles = StyleSheet.create({
  labelText: {
    flex: 1,
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 16,
  },
  input: {
    ...THEME.input,
    fontSize: 14,
    borderBottomWidth: 1,
    marginLeft: 20,
    marginRight: 20,
  },
  row: {
    flexDirection: 'row',
  },
  col: {
    flex: 1,
    justifyContent: 'flex-start',
  },
});
